import {Label} from '@/base/ui/label'
import {RadioGroup, RadioGroupItem} from '@/base/ui/radioGroup'
import {cn} from '@/lib/utils'
import React from 'react'
import {IWuRadioOption} from './types/IWuRadioOption'

export interface IWuRadioGroupProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  options: IWuRadioOption[]
  defaultValue?: string
  disabled?: boolean
  onChange?: (e: string) => void
  label?: string
  id?: string
  dir?: 'ltr' | 'rtl'
}

export const WuRadioGroup: React.FC<IWuRadioGroupProps> = React.forwardRef<
  HTMLInputElement,
  IWuRadioGroupProps
>((props, ref) => {
  const {options, defaultValue, onChange, label, dir, ...rest} = props

  return (
    <RadioGroup
      defaultValue={defaultValue}
      required={rest.required}
      disabled={rest.disabled}
      onValueChange={onChange}
      id={rest.id}
      dir={dir}
      name={rest.name}
      className={cn('w-fit', rest.className)}
      ref={ref}
      style={rest.style}
    >
      <Label
        htmlFor={rest.id}
        className="text-sm font-normal text-gray-lead leading-6 wu-radio-group-label"
      >
        {label}
      </Label>
      {options.map(option => {
        return (
          <div
            className="flex items-center gap-2 wu-radio-item-container"
            key={option.value}
          >
            <RadioGroupItem
              value={option.value}
              id={option.value}
              disabled={option.disabled}
              required={option.required}
              aria-label={option.value}
              className="peer wu-radio-item"
            />
            <Label
              htmlFor={option.value}
              className={cn(
                option.required &&
                  "after:content-['*'] after:mx-[2px] after:text-rose-500 wu-radio-item-label",
              )}
            >
              {option.label}
            </Label>
          </div>
        )
      })}
    </RadioGroup>
  )
})

WuRadioGroup.displayName = 'WuRadioGroup'
